export const PRODUCT_NAME = {
  DSL: 'DSL'
};
export const LEAD_SOURCE = {
  TALK_TO_EXPERT: 'TALK_TO_EXPERT'
};
export const SIEBEL_LEAD_ID = 'SIEBEL_LEAD_ID';
export const SELECTED_PLAN = 'selected_plan';
export const SELECTED_PLAN_VALUE = 'selected_plan_value';
export const MODULE_ID = 'b2b_online_acq_';
export const AUTHORIZATION_HEADER = 'Authorization';
export const AUTHORIZATION_NEW_HEADER = 'NewAuthorization';
export const CUSTOMER_DETAIL = 'customer_detail';
export const DEDICATED_CUSTOMER_DETAIL = 'dedicated_customer_detail';
export const INSTALLATION_PAGE_CUSTOMER_DETAIL = 'installation_customer';
export const DEDICATED_INSTALLATION_PAGE_CUSTOMER_DETAIL = 'dedicated_installation_customer';
export const FEASIBILITY_DATA = 'feasibilityData';
export const PROFILE_DATA = 'ProfileData';
export const LAST_XHR_FAILURE_MESSAGE = 'LastXhrFailureMessage';
export const SAVED_BILL_DURATION = 'SavedBillDuration';
export const LEAD = 'lead';
export const DEDICATED_FEASIBILITY_DATA = 'dedicated_feasibilityData';
export const FEASIBILITY_RESPONSE = 'feasibilityResponse';
export const DEDICATED_FEASIBILITY_RESPONSE = 'dedicated_feasibilityResponse';
export const AUTHORIZED_SIGNATORY = 'authorizedSignatory';
export const EKYC_DETAILS = 'ekycDetails';
export const BILLING_DETAILS = 'billingDetails';
export const POI_DETAILS = 'poiDetails';
export const UPLOAD_DOCS = 'uploadDocs';
export const POI_LIST = [
  { displayName: 'Passport', key: 'PASSPORT' },
  { displayName: 'Aadhaar Card', key: 'AADHAAR_ID' },
  { displayName: 'Voter Card', key: 'VOTER_ID' },
  { displayName: 'Driving Licence', key: 'DRIVING_LICENCE' }
  // { displayName: "PAN Card", key: "PAN" },
];
export const UPLOAD_DOC_LIST = {
  AADHAAR_FRONT: 'AADHAAR_FRONT',
  AADHAAR_BACK: 'AADHAAR_BACK',
  VOTER_CARD_FRONT: 'VOTER_CARD_FRONT',
  VOTER_CARD_BACK: 'VOTER_CARD_BACK',
  DL_FRONT: 'DL_FRONT',
  DL_BACK: 'DL_BACK',
  PASSPORT: 'PASSPORT'
};
export const AEH_LOB = 'aehLob';

export const DOCUMENT_TYPE_ENUM = {
  AUTHORIZED_SIGNATORY: 'AUTHORIZED_SIGNATORY'
};
export const CONSTANTDATA = {
  SET_LIMIT_10: 10
};

export const JOURNEY_STEPS = ['Check Availability', 'Choose a Plan', ' Booking Summary'];
export const JOURNEY_STEPS_KYC = ['Check Availability', 'Choose a Plan', 'Submit Order & Digital KYC'];
export const JOURNEY_STEPS_INDEX = {
  CHECK_AVAILABLITY: 1,
  CHOOSE_PLAN: 2,
  BOOKING_SUMMARY: 3
};

export const UNAUTH_DEDICATED_JOURNEY_STEPS = ['Check Availability', 'Get a Customized Quotation'];
export const UNAUTH_DEDICATED_STEPS_INDEX = {
  'Check Availability': 1,
  Get_QUOTATION: 2
};

export const FEASIBILITY_STATUS = {
  FEASIBLE: { key: 'FEASIBLE', value: 'Excellent Network' },
  FEASIBLE_HIGH_CONFIDENCE: { key: 'FEASIBLE_HIGH_CONFIDENCE', value: 'Excellent Network' },
  FEASIBLE_LOW_CONFIDENCE: { key: 'FEASIBLE_LOW_CONFIDENCE', value: 'Poor Network' },
  NOT_FEASIBLE_HIGH_CONFIDENCE: { key: 'NOT_FEASIBLE_HIGH_CONFIDENCE', value: 'No Network' },
  NOT_FEASIBLE_LOW_CONFIDENCE: { key: 'NOT_FEASIBLE_LOW_CONFIDENCE', value: 'Poor Network' },
  MANUAL_INTERVENTION_REQUIRED: { key: 'MANUAL_INTERVENTION_REQUIRED', value: 'Poor Network' }
};

export const serviceOptions = [
  { id: '1', displayName: 'Managed Services', value: 'MANAGED' },
  { id: '2', displayName: 'Unmanaged Services', value: 'UNMANAGED' }
];

export const contractOptions = [
  { id: '1', displayName: '1 year', value: 1, checked: true },
  { id: '2', displayName: '2 year', value: 2 },
  { id: '3', displayName: '3 years', value: 3 }
];
export const CAROUSEL_RESPONSIVE_CONSTANTS = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3
  },
  tabletbig: {
    breakpoint: { max: 1024, min: 767 },
    items: 2.7,
    slidesToSlide: 3
  },
  tabletsmall: {
    breakpoint: { max: 768, min: 675 },
    items: 2.05,
    slidesToSlide: 2
  },
  mobilebig: {
    breakpoint: { max: 674, min: 426 },
    items: 2,
    slidesToSlide: 2
  },
  mobile: {
    breakpoint: { max: 425, min: 0 },
    items: 1,
    slidesToSlide: 1,
    partialVisibilityGutter: 50
  }
};
export const CAROUSEL_RESPONSIVE_CONSTANTS_DOC = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    slidesToSlide: 1
  },
  tabletbig: {
    breakpoint: { max: 1024, min: 767 },
    items: 2,
    slidesToSlide: 1
  },
  tabletsmall: {
    breakpoint: { max: 768, min: 675 },
    items: 2,
    slidesToSlide: 1
  },
  mobilebig: {
    breakpoint: { max: 674, min: 426 },
    items: 1,
    slidesToSlide: 1
  },
  mobile: {
    breakpoint: { max: 425, min: 0 },
    items: 1,
    slidesToSlide: 1,
    partialVisibilityGutter: 0
  }
};
export const NOTIFICATION_TIMEOUT = 10;
export const SELECT_POP_UP = 'selectPopUp';
export const KNOW_MORE_POP_UP = 'knowMorePopUp';
export const DEFAULT_1_MONTH_PLAN = '1';
export const INITIATE_FETCHING = 'fetch data';
export const FETCH_SUCCESS = 'fetch data successfully';
export const FETCH_ERROR = 'error in fetching data';
export const HTTP_ERR_CODE = 'error code';
export const CUSTOMER_EMAIL = 'email';
export const CUSTOMER_PHONENUMER = 'phoneNumber';
export const CUSTOMER_NAME = 'customerName';
export const CUSTOMER_COMPANY_NAME = 'companyName';
export const CUSTOMER_OTP_SUCCESS = 'otpSuccess';
export const CUSTOMER_UNIQUEID = 'uniqueId';
export const CUSTOMER_CITY = 'city';
export const CUSTOMER_OFFICE_NAME = 'officeName';
export const CUSTOMER_ADDRESS_LINE = 'addressLine';
export const CUSTOMER_PIN_CODE = 'pinCode';
export const CUSTOMER_STATE = 'state';
export const CUSTOMER_GST_NUMBER = 'gstNumber';
export const CUSTOMER_PAN_NUMBER = 'panNumber';
export const CUSTOMER_BILLING_CITY = 'billingCity';
export const CUSTOMER_BILLING_TYPE_NAME = 'billingType';
export const CUSTOMER_BILLING_ADDRESS_LINE = 'billingAddressLine';
export const CUSTOMER_BILLING_PIN_CODE = 'billingPinCode';
export const CUSTOMER_BILLING_STATE = 'billingState';
export const CUSTOMER_AADHAAR_NUMBER = 'aadhaarNumber';
export const CUSTOMER_DL = 'drivingLicence';
export const CUSTOMER_PASS_PORT = 'passPort';
export const CUSTOMER_VOTER_CARD = 'voterCard';
export const COMPANY_TYPE = 'companyType';
export const DOC_ARRAY_AADHAR = {
  AADHAAR_FRONT: 'Aadhar Front',
  AADHAAR_BACK: 'Aadhar Back'
  //   OTHER: 'Other'
};
export const DOC_ARRAY_PAN = {
  PAN_FRONT: 'PAN Front'
  // PAN_BACK: 'PAN Back'
  //   OTHER: 'Other'
};

export const STANDARD_FILE_SIZE = 5;
export const INVALID_FILE_SIZE_MESSAGE = 'File size has exceeded it max limit of 5MB...Retry';
export const IMAGE_FILE_FORMATS = ['.tif', '.tiff', '.jpg', '.jpeg', '.gif', '.bmp', '.png', '.eps'];
export const DOC_TYPE_PURCHASE_ORDER_LOA = 'PURCHASE_ORDER_LOA';
export const DOC_TYPE_KDM = 'KDM';
export const DOOR_STEP_MESSAGE = 'Our agent will visit your preferred address for KYC documentation.';
export const DOOR_STEP_TITLE = 'Doorstep KYC Assistance';
export const INSTRUCTION_MESSAGE =
  "<p class='text-heading-kyc'>Provide a photo identification of your company and authorized person.</p></p><p>1. GSTN: copies of Annexure A, Annexure B and GSTN Certificate.</p><p>2. PAN: copies of Certificate of Incorporation (COI) copy and PAN.</p><p class='text-heading-door'> Alternatively, you can request doorstep assistance by visiting 'Need Assistance for KYC' on our website. Our executive will contact you within 24 hours..</p>";
export const INSTRUCTION_TITLE = 'Digital KYC for installation within 4 hours!!!';
export const CLEAR_IMAGE_TITLE = 'Remove Attachments';
export const CLEAR_IMAGE_MESSAGE = 'Are you sure that you want to remove all the documents attached? ';
export const CHANGE_COMPANY_POPUP_TITLE = 'Change Company ID Type';
export const CHANGE_COMPANY_POPUP_MESSAGE = 'Switching between PAN/GSTN would reset the details filled.';
export const CHECK_COMPANY_NAME_MESSAGE = 'Company name provided earlier does not match with the GST details. You may please re-verify & proceed accordingly.';
export const CHANGE_PLAN_TITLE = 'Change Plan';
export const CHANGE_PLAN_MESSAGE = 'All details added by you will be removed after changing the selected plan. Are you sure you want to change it?';
export const OV_REJECTED = 'OV_REJECTED';
export const ORDER_IN_PROGRESS = 'ORDER_IN_PROGRESS';
export const MOENGAGE_ANALYTICS_EVENT = {
  PRODUCT_WHATSAPP: 'ACQ_BB_INT_PROD_WHATSAPP',
  PRODUCT_PAGE_VISIT: 'ACQ_BB_INT_PROD_PG_VISIT',
  PRODUCT_BUY_NOW: 'ACQ_BB_INT_PROD_BUY_NOW',
  PRODUCT_CALL_US: 'ACQ_BB_INT_PROD_CALL_US',
  PRODUCT_TALK_TO_EXPERT_CTA: 'ACQ_BB_INT_PROD_TTE_CTA',
  PRODUCT_TALK_TO_EXPERT: 'ACQ_BB_INT_PROD_TALK_TO_EXPERT',
  PRODUCT_TRY_NOW_BTN: 'ACQ_BB_INT_PROD_TRY_NOW',
  CHECK_FEASIBILITY_PAGE_VISIT: 'ACQ_BB_INT_CHK_FEASIB_PG_VISIT',
  SUBMIT_CUSTOMER_DEATILS: 'ACQ_BB_INT_SUBMIT_CUSTOMER_DEATILS',
  SUBMIT_FEASIBILITY: 'ACQ_BB_INT_SUBMIT_FEASIBILITY',
  PLAN_PAGE_VISIT: 'ACQ_BB_INT_PLAN_PAGE_VISIT',
  PROCCED_PLAN: 'ACQ_BB_INT_PROCCED_PLAN',
  SUMMARY_PAGE_VISIT: 'ACQ_BB_INT_SUMMARY_PG_VISIT',
  SUBMIT_SUMMARY: 'ACQ_BB_INT_SUBMIT_SUMMARY',
  EKYC_PAGE_VISIT: 'ACQ_BB_INT_EKYC_PG_VISIT',
  THANK_YOU_PAGE_VISIT: 'ACQ_BB_INT_THANK_YOU_PG_VISIT',
  SELECT_PLAN: 'ACQ_BB_INT_SELECT_PLAN',
  DOORSTEP_SERVICE: 'ACQ_BB_INT_DOORSTEP_SERVICE',
  UPLOAD_DOCUMENTS: 'ACQ_BB_INT_UPLOAD_DOCUMENTS',
  SUBMIT_ORDER: 'ACQ_BB_INT_SUBMIT_ORDER',
  PRODUCT_BANNER: 'ACQ_BB_INT_PRODUCT_BANNER_CLICK'
};
export const MOENGAGE_ANALYTICS_AUTH_EVENT = {
  PRODUCT_PAGE_VISIT: 'ACQ_AUTH_BB_INT_PROD_PG_VISIT',
  PRODUCT_BUY_NOW: 'ACQ_AUTH_BB_INT_PROD_BUY_NOW',
  PRODUCT_CALL_US: 'ACQ_AUTH_BB_INT_PROD_CALL_US',
  PRODUCT_TALK_TO_EXPERT_CTA: 'ACQ_AUTH_BB_INT_PROD_TTE_CTA',
  PRODUCT_TALK_TO_EXPERT: 'ACQ_AUTH_BB_INT_PROD_TALK_TO_EXPERT',
  PRODUCT_TRY_NOW_BTN: 'ACQ_AUTH_BB_INT_PROD_TRY_NOW',
  CHECK_FEASIBILITY_PAGE_VISIT: 'ACQ_AUTH_BB_INT_CHK_FEASIB_PG_VISIT',
  SUBMIT_CUSTOMER_DEATILS: 'ACQ_AUTH_BB_INT_SUBMIT_CUSTOMER_DEATILS',
  SUBMIT_FEASIBILITY: 'ACQ_AUTH_BB_INT_SUBMIT_FEASIBILITY',
  PLAN_PAGE_VISIT: 'ACQ_AUTH_BB_INT_PLAN_PAGE_VISIT',
  PROCCED_PLAN: 'ACQ_AUTH_BB_INT_PROCCED_PLAN',
  SUMMARY_PAGE_VISIT: 'ACQ_AUTH_BB_INT_SUMMARY_PG_VISIT',
  SUBMIT_SUMMARY: 'ACQ_AUTH_BB_INT_SUBMIT_SUMMARY',
  EKYC_PAGE_VISIT: 'ACQ_AUTH_BB_INT_EKYC_PG_VISIT',
  THANK_YOU_PAGE_VISIT: 'ACQ_AUTH_BB_INT_THANK_YOU_PG_VISIT',
  SELECT_PLAN: 'ACQ_AUTH_BB_INT_SELECT_PLAN',
  DOORSTEP_SERVICE: 'ACQ_AUTH_BB_INT_DOORSTEP_SERVICE',
  UPLOAD_DOCUMENTS: 'ACQ_AUTH_BB_INT_UPLOAD_DOCUMENTS',
  SUBMIT_ORDER: 'ACQ_AUTH_BB_INT_SUBMIT_ORDER',
  PRODUCT_BANNER: 'ACQ_AUTH_BB_INT_PRODUCT_BANNER_CLICK'
};
export const SUB_NAV_TEXT = {
  overview: 'Overview',
  ourSolutions: 'Our Solutions',
  pricing: 'Pricing and Comparison',
  getStarted: 'Get Started',
  advantage: 'Advantage',
  contactUs: 'Contact Us',
  faqs: 'FAQs'
};

export const ENUMS = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve'];
export const PINCODE_ERROR_API = 'Please enter a valid PINCODE';
